import axios from "axios";
import { getAccessToken } from "../auth/msal/helpers";
import { User } from "../types";

const api = axios.create({
  baseURL: process.env.CACTAI_REST_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Fetches user data from the API
 * @param oid The unique oid returned from msal login
 * @returns A Promise that resolves to the user data
 */
export const sendFeedback = async (messageID: string, feedback: 'liked' | 'disliked' | null) => {
  try {
    const token = await getAccessToken();
    const response = await api.post<any>(
      `/feedback`,
        { messageID, feedback},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.status === 200;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      console.log("Axios error:", error.response?.data);
    } else {
      console.log("General error:", error);
    }
    throw error;
  }
};
